export const EMAIL_REGEX =
  /^([a-zA-Z0-9_!#$%&'*+-/=?^`{|}~.]+)@([a-zA-Z0-9_\-.]+).([a-zA-Z]{2,5})$/i;
export const PASSWORD_REGEX =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[/\W|_/g])[A-Za-z\d/\W|_/g]{8,}$/i;
export const PHONE_NUMBER_REGEX =
  /^(\+\d{1,2}\s?)?1?\-?\.?\s?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/i;
export const BASE_FONT_SIZE = 16;
